export const years = Array.from({ length: 200 }, (_, i) => 1950 + i);
export const monthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export enum PickerHeaderType {
	BILLING = 'BILLING',
	INVOICE = 'INVOICE',
}
